import { ChangeEvent, ComponentPropsWithoutRef, useEffect, useRef, useState } from 'react';
import TextInput from '@/components/functional/TextInput/TextInput.tsx';

export function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}: {
  debounce?: number;
  value: string | number;
  onChange: (value: string | number) => void;
} & Omit<ComponentPropsWithoutRef<typeof TextInput>, 'onChange' | 'value'>) {
  const [value, setValue] = useState(initialValue);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleSetValue = (e: ChangeEvent<HTMLInputElement>) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    setValue(e.target.value);

    timeoutRef.current = setTimeout(() => {
      if (onChange) {
        onChange(e.target.value!);
      }
    }, debounce);
  };

  return <TextInput {...props} value={value} onChange={handleSetValue} />;
}
